import _ = require("lodash");
import {
  ExcelColorValue,
  UploadStatus,
  Constants,
  CommonColumn,
  CommonConfiguration,
  CellIndexMapping,
  ColumnType,
} from "../../util/UIConstants";
import { EntityConfiguration, IUIExcelInterface } from "../../configurations/configuration";
import { isNullOrUndefined, isNullOrWhitespace, currentResource, labels } from "../../util/utils";
import { ServiceDataModel } from "../models/Models";
import { Environment } from "../../util";
import { ExcelUtilityHelper } from "../../helpers/common/ExcelUtilityHelper";
import { ExcelHelper } from "../../helpers/ExcelHelper";
import hash = require("object-hash");
import Utility from "../../util/utilityFunctions";
export class TemplateUIExcelInterface implements IUIExcelInterface {
  constructor() {}

  InsertEmptyRows(data, configuration, engagementIdToRender?): any {
    let apiTemplate = configuration.entityConfiguration.apiTemplate;
    const MAX_ROWS_EXCEL = apiTemplate?.get.NoOfEmptyRowsToInsert ? apiTemplate?.get.NoOfEmptyRowsToInsert : 2000;
    const titleHashValue = hash("");
    //data = new Array(MAX_ROWS_EXCEL).fill("");

    let rowsArray = new Array<any>();
    // header row

    let headerRow = TemplateUIExcelInterface.getHeaderDataRow(configuration.columns);

    rowsArray.push(headerRow);

    for (let i = 0; i < MAX_ROWS_EXCEL; i++) {
      let rowData = new Array<any>();
      configuration.columns.forEach((column) => {
        let columnData = "";
        if (column?.CellId == ColumnType.HashValue) {
          columnData = titleHashValue;
        }
        rowData.push(columnData);
      });

      rowsArray.push(rowData);
    }
    return rowsArray;
  }

  getMappedListData(data, configuration, engagementIdToRender): any {
    let apiTemplate = configuration.entityConfiguration.apiTemplate;
    if (apiTemplate?.get.url) {
      let rowsArray = new Array<any>();
      // header row
      let rowData = new Array<any>();

      rowData = TemplateUIExcelInterface.getHeaderDataRow(configuration.columns);

      rowsArray.push(rowData);
      let orderByAttribute = apiTemplate.get.orderByAttributeName;
      let dataList = data.response;
      const referenceData = data?.referenceData;
      if (apiTemplate.get.dataAttributeName) {
        dataList = dataList[apiTemplate.get.dataAttributeName];
      }
      let sortedResponse = dataList;
      if (data && dataList && dataList?.length && orderByAttribute) {
        sortedResponse = dataList.sort(function (a, b) {
          return String(a[orderByAttribute] ?? "").localeCompare(String(b[orderByAttribute] ?? ""));
        });
        //sortedResponse = _.sortBy(dataList, orderByAttribute);
      }
      if (sortedResponse) {
        sortedResponse.forEach((request) => {
          let rowData = TemplateUIExcelInterface.getDataRow(
            configuration.columns,
            request,
            configuration,
            {
              engagementId: engagementIdToRender,
            },
            referenceData
          );
          rowsArray.push(rowData);
        });
        return rowsArray;
      }
    } else {
      // if no url then insert empty rows
      const rowsArray = this.InsertEmptyRows(data, configuration, engagementIdToRender);
      return rowsArray;
    }
  }

  public static updateReferenceSheetHeaders = (referenceSheetConfig) => {
    referenceSheetConfig = referenceSheetConfig.map((column) => ({
      ...column,
      CellHeader: currentResource[column.CellHeaderResourceName]?.[column.CellHeader] || labels[column.CellHeader],
    }));

    return referenceSheetConfig;
  };

  public static getHeaderDataRow(columns): any {
    let rowData = new Array<any>();
    columns.forEach((cellColumn) => {
      const headerValue = cellColumn?.CellHeaderResourceName
        ? currentResource[cellColumn?.CellHeaderResourceName][cellColumn.CellHeader]
        : labels[cellColumn.CellHeader];
      rowData.push(headerValue ? headerValue : cellColumn.CellHeader);
    });

    return rowData;
  }

  public static getDataRow(columns, dataRow, configuration, input, referenceData = null): any {
    let rowData = new Array<any>();
    columns.forEach((cellColumn) => {
      rowData.push(TemplateUIExcelInterface.getCellData(dataRow, cellColumn, configuration, input, referenceData));
    });

    return rowData;
  }

  static getConcatenatedData(rowData: any, column: any, configuration: EntityConfiguration): any {
    let sourceData = rowData[column.CellData?.sourceDataAttributeName];
    let seprator = column.CellData?.seprator ? column.CellData?.seprator : "; ";
    return (
      sourceData &&
      sourceData
        .map((item) => {
          if (column.CellData.cellDataTemplate) {
            const dataFunction = new Function(
              "rowData",
              "item",
              "configuration",
              "labels",
              column.CellData.cellDataTemplate
            );
            // Test the function with some data
            const data = dataFunction(rowData, item, configuration, labels);
            return data;
          }
          return item[column.CellData.dataAttributeName];
        })
        .join(seprator)
    );
  }

  static getDataBasedOnCellDataTemplate(
    rowData: any,
    column: any,
    configuration: EntityConfiguration,
    labels: any,
    inputData: any = null
  ): any {
    const dataFunction = new Function(
      "rowData",
      "configuration",
      "input",
      "labels",
      column?.CellData?.cellDataTemplate
    );
    // Test the function with some data
    let data = dataFunction(rowData, configuration, inputData, labels);
    data = data ? data.trim() : "";
    return data;
  }

  static getCellData(
    rowData: any,
    column: any,
    configuration: EntityConfiguration,
    engagementId,
    referenceData = null
  ): any {
    if (typeof column.getCellData === "function") {
      const data = column.getCellData(rowData, configuration, { engagementId: engagementId }, labels, referenceData);
      return data;
    }

    if (column.CellData) {
      if (column.CellData.dataAttributeName) {
        const value = rowData[column.CellData.dataAttributeName];
        if (column.CellData.resourceName) {
          let resourceData = currentResource[column.CellData.resourceName];
          if (_.isArray(resourceData)) {
            const data = resourceData.find((x) => x.value === value);
            return data ? data.label : value;
          } else {
            let labelValue = currentResource[column.CellData.resourceName][value];
            return labelValue ? labelValue : value;
          }
        }

        if (column.dataType == "richText") {
          return Utility.getFormatedDescriptionToExcelFormat(value);
        }

        if (
          column.CellData?.dataType == "list" &&
          column.CellData?.dataMode == "concatenate" &&
          column.CellData?.sourceDataAttributeName
        ) {
          return this.getConcatenatedData(rowData, column, configuration);
        }

        return value ? value : "";
      }
      let value = column.CellData.value;

      if (column.CellData.resourceName) {
        let labelValue = currentResource[column.CellData.resourceName][value];
        return labelValue ? labelValue : value;
      }

      if (value) {
        return value;
      }
    }

    // "getCellData": "function(rowData, configuration, input) { if (rowData.isShared) { if (rowData.engagementId == input?.engagementId) {  return labels.ownedByEngagement; }  return labels.sharedToEngagement;; } return ''"
    if (column?.CellData?.cellDataTemplate) {
      // Test the function with some data
      const data = this.getDataBasedOnCellDataTemplate(rowData, column, configuration, labels, {
        engagementId: engagementId,
      });
      return data;
    }

    if (column.CellId == ColumnType.HashValue) {
      let haskAttributesNames = column.HashAttribue.HashCalculatedDataattributesName;
      let fullHashText = "";
      haskAttributesNames.map((item) => {
        if (item != "" && item != null && item != undefined) {
          let dataAttributeName = item.dataAttributeName;
          let data = "";
          if (!dataAttributeName) {
            let dataColumn = configuration.columns.find((x) => x.CellId == item.CellId);
            if (dataColumn?.CellData.resourceName) {
              const value = rowData[dataColumn.CellData.dataAttributeName];
              const resourceData = currentResource[dataColumn.CellData.resourceName];
              if (_.isArray(resourceData)) {
                const dataItem = resourceData.find((x) => x.value === value);
                data = dataItem && dataItem.label;
              } else {
                let labelValue = resourceData[value];
                data = labelValue && labelValue;
              }
            } else if (dataColumn["dataType"] == "richText") {
              const dataValue = rowData[dataColumn.CellData.dataAttributeName];
              data = Utility.getFormatedDescriptionToExcelFormat(dataValue);
            } else if (
              dataColumn.CellData?.dataType == "list" &&
              dataColumn.CellData?.dataMode == "concatenate" &&
              dataColumn.CellData?.sourceDataAttributeName
            ) {
              data = this.getConcatenatedData(rowData, dataColumn, configuration);
            } else if (dataColumn?.CellData?.cellDataTemplate) {
              // Test the function with some data
              data = this.getDataBasedOnCellDataTemplate(rowData, dataColumn, configuration, labels, {
                engagementId: engagementId,
              });
            } else {
              data = rowData[dataColumn.CellData.dataAttributeName];
            }
          } else {
            data = rowData[dataAttributeName];
          }

          if (data == null || data == undefined || data?.trim() == "") {
            data = "";
          }
          fullHashText += data;
        }
      });
      let hashValue: string = hash(fullHashText);

      return hashValue;
    }

    return "";
  }

  private getErrorMessage(cellDetail: any, rule: any): string {
    let validationMessage = "";
    if (rule.errorDetails?.errorCode) {
      const labelMessage = currentResource.errors[rule.errorDetails?.errorCode];
      validationMessage = labelMessage ? labelMessage : rule.errorDetails?.defaultMessage;
    }

    if (rule.errorDetails?.labelKey) {
      const labelMessage = labels[rule.errorDetails?.labelKey];
      if (labelMessage && cellDetail.CellHeaderResourceName) {
        validationMessage = labelMessage.replaceAll(
          "{0}",
          currentResource?.[cellDetail.CellHeaderResourceName]?.[cellDetail.CellHeader]
        );
      } else if (labelMessage && cellDetail.CellHeader) {
        validationMessage = labelMessage.replaceAll("{0}", cellDetail.CellHeader);
      }
    }

    if (!validationMessage) {
      validationMessage = rule.errorDetails?.defaultMessage;
    }

    return validationMessage;
  }

  static getErrorMessage(cellDetail, errorDetails: any): string {
    let validationMessage = "";
    if (errorDetails?.errorCode) {
      const labelMessage = currentResource.errors[errorDetails?.errorCode];
      validationMessage = labelMessage ? labelMessage : errorDetails?.defaultMessage;
    }

    if (errorDetails?.labelKey) {
      const labelMessage = labels[errorDetails?.labelKey];
      if (labelMessage && cellDetail.CellHeaderResourceName) {
        validationMessage = labelMessage.replaceAll(
          "{0}",
          currentResource?.[cellDetail.CellHeaderResourceName]?.[cellDetail.CellHeader]
        );
      } else if (labelMessage && cellDetail.CellHeader) {
        validationMessage = labelMessage.replaceAll("{0}", cellDetail.CellHeader);
      }
    }

    if (!validationMessage) {
      validationMessage = errorDetails?.defaultMessage;
    }

    return validationMessage;
  }

  private async NotEmptyValidation(inputValidationRule, configuration, updatedRow) {
    let validationMessage = null;
    for (const rule of inputValidationRule.NotEmptyValidation) {
      let hasValueInOriginalCell = false;
      if (rule.groupedAttributesValidation) {
        for (let i = 0; i < rule.groupedAttributesValidation.length; i++) {
          const validation = rule.groupedAttributesValidation[i];
          let cellDetailOriginal = configuration.columns.find((x) => x.CellId == validation.originalCellId);
          let originalCellValue = updatedRow.values.at(0)[cellDetailOriginal.CellDisplayIndex];
          if (!Utility.isInvalidValue(originalCellValue)) {
            console.log("originalCellValue", originalCellValue);
            hasValueInOriginalCell = true;
            break;
          }
        }

        let hasValueInCellData = false;
        if (hasValueInOriginalCell == true) {
          for (let i = 0; i < rule.groupedAttributesValidation.length; i++) {
            const validation = rule.groupedAttributesValidation[i];
            let cellDetail = configuration.columns.find((x) => x.CellId == validation.cellId);
            let updatedCellValue = updatedRow.values.at(0)[cellDetail.CellDisplayIndex];
            if (!Utility.isInvalidValue(updatedCellValue)) {
              hasValueInCellData = true;
              break;
            }
          }
        }

        if (hasValueInOriginalCell && !hasValueInCellData) {
          validationMessage = this.getErrorMessage(null, rule);
          return validationMessage;
        }
      } else {
        let cellDetail = configuration.columns.find((x) => x.CellId == rule.cellId);
        let cellDetailOriginal = configuration.columns.find((x) => x.CellId == rule.originalCellId);
        let updatedCellValue = updatedRow.values.at(0)[cellDetail.CellDisplayIndex];
        let originalCellValue = updatedRow.values.at(0)[cellDetailOriginal.CellDisplayIndex];
        if (!Utility.isInvalidValue(originalCellValue) && Utility.isInvalidValue(updatedCellValue)) {
          if (rule.parentCellId) {
            let parentCellDetail = configuration.columns.find((x) => x.CellId == rule.parentCellId);
            let parentCellValue = updatedRow.values.at(0)[parentCellDetail.CellDisplayIndex];

            let parentOriginalCellDetail = configuration.columns.find((x) => x.CellId == rule.parentOriginalCellId);
            let parentOriginalCellValue = updatedRow.values.at(0)[parentOriginalCellDetail.CellDisplayIndex];

            if (
              !Utility.isInvalidValue(parentOriginalCellValue) ||
              (Utility.isInvalidValue(parentCellValue) && Utility.isInvalidValue(parentOriginalCellValue))
            ) {
              const labelMessage = currentResource.errors[rule.errorDetails?.errorCode];
              validationMessage = labelMessage ? labelMessage : rule.errorDetails?.defaultMessage;
              return validationMessage;
            }
          } else {
            validationMessage = this.getErrorMessage(cellDetail, rule);
            return validationMessage;
          }
        }
      }
    }

    return validationMessage;
  }

  private async DuplicateValidation(inputValidationRule, configuration, updatedRow, duplicateInputData) {
    // this is specfic to document where we can give duplicate document name
    let validationMessage = null;
    let concategatedName = "";
    inputValidationRule.dupliateOutputData.forEach((rule) => {
      let cellDetail = configuration.columns.find((x) => x.CellId == rule.cellId);
      concategatedName = concategatedName + updatedRow.values.at(0)[cellDetail.CellDisplayIndex] + "_";
    });

    const count = duplicateInputData.filter((docName) => docName === concategatedName).length;
    if (count > 1) {
      const firstItem = inputValidationRule.dupliateOutputData[0];
      const labelMessage = labels[firstItem.errorDetails?.labelKey];
      validationMessage = labelMessage ? labelMessage : firstItem.errorDetails?.defaultMessage;
    }

    return validationMessage;
  }

  private InvalidInputDataValidation(inputValidationRule, configuration, updatedRow) {
    let validationMessage = null;
    for (const rule of inputValidationRule.invalidInputData) {
      let cellDetail = configuration.columns.find((x) => x.CellId == rule.cellId);
      let updatedName = updatedRow.values.at(0)[cellDetail.CellDisplayIndex];
      if (rule.invalidData.includes(updatedName)) {
        validationMessage = this.getErrorMessage(cellDetail, rule);
        return validationMessage;
      }
    }
    return validationMessage;
  }

  private MaxLengthValidation(inputValidationRule, configuration, updatedRow) {
    let validationMessage = null;
    for (const rule of inputValidationRule.maxlenghtValidation) {
      let cellDetail = configuration.columns.find((x) => x.CellId == rule.cellId);
      if (cellDetail) {
        let updatedName = updatedRow.values.at(0)[cellDetail.CellDisplayIndex].toString().trim();
        if (updatedName && cellDetail?.["dataType"] == "richText") {
          updatedName = Utility.convertNewLinesToParagraphs(updatedName);
        }
        if (updatedName.length > rule.maxLength) {
          validationMessage = this.getErrorMessage(cellDetail, rule);
          return validationMessage;
        }
      }
    }
    return validationMessage;
  }
  private async RequiredValidation(inputValidationRule, configuration, updatedRow) {
    let validationMessage = null;
    for (const rule of inputValidationRule.requiredValidation) {
      let cellDetail = configuration.columns.find((x) => x.CellId == rule.cellId);
      if (cellDetail) {
        let updatedName = updatedRow.values.at(0)[cellDetail.CellDisplayIndex];
        if (isNullOrUndefined(updatedName) || isNullOrWhitespace(updatedName.toString())) {
          validationMessage = this.getErrorMessage(cellDetail, rule);
          return validationMessage;
        }
      }
    }
    return validationMessage;
  }
  private async LookUpValidation(inputValidationRule, configuration, updatedRow, data, userLanguage, apiTemplate) {
    let validationMessage = null;
    for (const rule of inputValidationRule.lookUpValidation) {
      let cellDetail = configuration.columns.find((x) => x.CellId == rule.cellId);
      let compareValueAttributeName = "value";
      if (cellDetail?.referenceData?.getCellData) {
        compareValueAttributeName = "label";
      }
      let updatedValue = updatedRow.values.at(0)[cellDetail.CellDisplayIndex];
      if (
        cellDetail.CellData?.dataType == "list" &&
        cellDetail.CellData?.dataMode == "concatenate" &&
        data?.[cellDetail.CellId + "referenceData"]
      ) {
        let delimiter = "; ";
        if (cellDetail?.referenceData?.delimiter) {
          delimiter = cellDetail.referenceData.delimiter;
        }

        let cellDataSelectedValues = updatedValue
          ?.toString()
          .split(delimiter)
          .map((item) => item);
        let cellDataOriginalData = undefined;
        if (apiTemplate?.updateOutputAttributes) {
          const lookupOutputAttribute = apiTemplate.updateOutputAttributes.find((x) => x.cellId == rule.cellId);
          if (lookupOutputAttribute.fetchValueFromOriginalCell) {
            // this data will be used to find what records needs to delete from database. For eg which EY contacts are deleted
            const cellDetailOriginal = configuration.columns.find(
              (x) => x.CellId === lookupOutputAttribute.originalCellId
            );
            const valueOriginal = updatedRow.values.at(0)[cellDetailOriginal.CellDisplayIndex];
            let delimiter = "; ";
            if (cellDetail?.["referenceData"]?.delimiter) {
              delimiter = cellDetail?.["referenceData"]?.delimiter;
            }

            cellDataOriginalData = !_.isEmpty(valueOriginal.toString().trim()) ? valueOriginal?.split(delimiter) : "";
          }
        }

        let lookDataUpList = data?.[cellDetail.CellId + "referenceData"];
        let updatedValues = cellDataSelectedValues;
        if (cellDataOriginalData) {
          let matchingIds = _.intersection(cellDataSelectedValues, cellDataOriginalData);
          updatedValues = _.difference(cellDataSelectedValues, matchingIds);
        }
        updatedValues.forEach((item) => {
          let lookupDataValue = lookDataUpList.find((x) => x.value === item);
          if (!lookupDataValue && item?.toString().trim()) {
            validationMessage = this.getErrorMessage(cellDetail, rule);
            return validationMessage;
          }
        });
      } else if (
        updatedValue &&
        data?.[cellDetail.CellId + "referenceData"] &&
        Object.values(data[cellDetail.CellId + "referenceData"]).every(
          (obj: any) => obj[compareValueAttributeName] != updatedValue
        )
      ) {
        if (!validationMessage) {
          validationMessage = this.getErrorMessage(cellDetail, rule);
        }
        return validationMessage;
      }
      if (cellDetail.validateImpactedCells) {
        const referenceData = data[cellDetail.CellId + "referenceData"];
        validationMessage = cellDetail.validateImpactedCells(
          updatedValue,
          rule,
          updatedRow.values.at(0),
          referenceData
        );

        if (validationMessage) {
          return validationMessage;
        }
      }
    }
    return validationMessage;
  }

  private async NotEqualValidation(inputValidationRule, configuration, updatedRow) {
    let validationMessage = null;
    for (const rule of inputValidationRule.notEqualValidation) {
      let cellDetail = configuration.columns.find((x) => x.CellId == rule.cellId);
      let cellDetailParent = configuration.columns.find((x) => x.CellId == rule.parentCellId);

      let updatedValue = updatedRow.values.at(0)[cellDetail.CellDisplayIndex];

      let updatedValueParent = updatedRow.values.at(0)[cellDetailParent.CellDisplayIndex];

      if (!Utility.isInvalidValue(updatedValue) && !Utility.isInvalidValue(updatedValueParent)) {
        if (rule.operatorType == "notEqual") {
          let parentdataSplitted = "";
          if (rule.delimiter) {
            parentdataSplitted = updatedValueParent.split(rule.delimiter);
            parentdataSplitted = parentdataSplitted[0];
          }
          if (parentdataSplitted && updatedValue !== parentdataSplitted) {
            validationMessage = this.getErrorMessage(cellDetail, rule);
            return validationMessage;
          }
        }

        if (rule.operatorType == "contains") {
          updatedValue = rule.delimiter ? updatedValue + rule.delimiter : updatedValue;
          const regexToMatch = new RegExp(`^${updatedValue}`);
          if (updatedValueParent && !regexToMatch.test(updatedValueParent)) {
            validationMessage = this.getErrorMessage(cellDetail, rule);
            return validationMessage;
          }
        }
      }
    }
    return validationMessage;
  }

  private async RegexValidation(inputValidationRule, configuration, updatedRow) {
    let validationMessage = null;
    for (const rule of inputValidationRule.regexValidation) {
      let cellDetail = configuration.columns.find((x) => x.CellId == rule.cellId);
      if (cellDetail) {
        let updatedName = updatedRow.values.at(0)[cellDetail.CellDisplayIndex].toString().trim();
        const regex = new RegExp(rule.regex);
        if (updatedName && regex.test(updatedName)) {
          validationMessage = this.getErrorMessage(cellDetail, rule);
          return validationMessage;
        }
      }
    }
    return validationMessage;
  }

  private async dateValidation(inputValidationRule, configuration, updatedRow) {
    let validationMessage = null;
    for (const rule of inputValidationRule.dateValidation) {
      let cellDetail = configuration.columns.find((x) => x.CellId == rule.cellId);
      if (cellDetail) {
        let updatedName = updatedRow.values.at(0)[cellDetail.CellDisplayIndex].toString().trim();
        if (updatedName) {
          const [year, month, day] = updatedName.split("-").map(Number);
          const date = new Date(Date.UTC(year, month - 1, day));

          // Check if it's a valid date and in correct format
          if (isNaN(date.getTime()) || !updatedName.match(/^\d{4}-\d{1,2}-\d{1,2}$/)) {
            validationMessage = this.getErrorMessage(cellDetail, rule);
            return validationMessage;
          }

          // Verify the date components match (catches invalid dates like 2025-09-31)
          if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) {
            validationMessage = this.getErrorMessage(cellDetail, rule);
            return validationMessage;
          }
        }
      }
    }
    return validationMessage;
  }

  private async HasSameDataValidation(inputValidationRule, configuration, updatedRow) {
    let validationMessage = null;
    // this is specfic to document where we don't want to send if original and new name is same because doc service return error if new and old document name is same
    for (const rule of inputValidationRule.hasSameData) {
      let cellDetailSource = configuration.columns.find((x) => x.CellId == rule.cellIdSource);
      let cellDetailDestination = configuration.columns.find((x) => x.CellId == rule.cellIdDestination);
      let updatedName = "";
      if (cellDetailSource) {
        updatedName = updatedRow.values.at(0)[cellDetailSource.CellDisplayIndex];
        if (isNullOrUndefined(updatedName) || isNullOrWhitespace(updatedName.toString())) {
          validationMessage = this.getErrorMessage(cellDetailSource, rule);
        }
      }
      let originalName = "";
      if (cellDetailDestination) {
        originalName = updatedRow.values.at(0)[cellDetailDestination.CellDisplayIndex];
        if (isNullOrUndefined(updatedName) || isNullOrWhitespace(updatedName.toString())) {
          validationMessage = this.getErrorMessage(cellDetailDestination, rule);
        }
      }

      if (updatedName.toString().trim() == originalName.toString().trim()) return { hasSameName: true };
    }
    return validationMessage;
  }

  // Validates the input values
  // and returns either a string if there is an error, or null otherwise.
  public async ValidateInputValues(
    updatedRow: Excel.TableRow,
    configuration,
    duplicateInputData: Array<string>,
    data: any = {},
    userLanguage: any
  ) {
    // To Do: Return once one validation fail, handle for each if more then one cell error, regex validation not working, may be expression is wrong
    let validationMessage = null;
    let apiTemplate = configuration.entityConfiguration["apiTemplate"];
    let inputValidationRule = configuration.entityConfiguration["inputValidationRule"];
    if (inputValidationRule?.NotEmptyValidation) {
      validationMessage = await this.NotEmptyValidation(inputValidationRule, configuration, updatedRow);
      if (validationMessage) {
        return validationMessage;
      }
    }

    if (inputValidationRule?.dupliateOutputData) {
      validationMessage = await this.DuplicateValidation(
        inputValidationRule,
        configuration,
        updatedRow,
        duplicateInputData
      );
      if (validationMessage) {
        return validationMessage;
      }
    }
    if (inputValidationRule?.invalidInputData) {
      validationMessage = await this.InvalidInputDataValidation(inputValidationRule, configuration, updatedRow);
      if (validationMessage) {
        return validationMessage;
      }
    }
    if (inputValidationRule?.maxlenghtValidation) {
      validationMessage = await this.MaxLengthValidation(inputValidationRule, configuration, updatedRow);
      if (validationMessage) {
        return validationMessage;
      }
    }
    if (inputValidationRule?.requiredValidation) {
      validationMessage = await this.RequiredValidation(inputValidationRule, configuration, updatedRow);
      if (validationMessage) {
        return validationMessage;
      }
    }

    if (inputValidationRule?.lookUpValidation) {
      validationMessage = await this.LookUpValidation(
        inputValidationRule,
        configuration,
        updatedRow,
        data,
        userLanguage,
        apiTemplate
      );
      if (validationMessage) {
        return validationMessage;
      }
    }

    if (inputValidationRule?.notEqualValidation) {
      validationMessage = await this.NotEqualValidation(inputValidationRule, configuration, updatedRow);
      if (validationMessage) {
        return validationMessage;
      }
    }

    if (inputValidationRule?.dateValidation) {
      validationMessage = await this.dateValidation(inputValidationRule, configuration, updatedRow);
      if (validationMessage) {
        return validationMessage;
      }
    }

    if (inputValidationRule?.regexValidation) {
      validationMessage = await this.RegexValidation(inputValidationRule, configuration, updatedRow);
      if (validationMessage) {
        return validationMessage;
      }
    }
    if (inputValidationRule?.hasSameData) {
      validationMessage = await this.HasSameDataValidation(inputValidationRule, configuration, updatedRow);
      if (validationMessage) {
        return validationMessage;
      }
    }

    let markUpdateValue = updatedRow.values.at(0)[CommonColumn.markUpdateValue];

    if (markUpdateValue !== Constants.MarkForUpdateYes && markUpdateValue !== Constants.MarkForUpdateNo)
      return labels.markValueInvalid;

    return validationMessage;
  }

  public async updateRequestPayloadBasedOnCellId(
    cellId: string,
    payloadDataAttributeName: string,
    updatedRow: Excel.TableRow,
    configuration: EntityConfiguration,
    requestPayload: any,
    data: ServiceDataModel,
    parentDataAttributeName: string
  ) {
    let cellDetail = configuration.columns.find((x) => x.CellId == cellId);
    let updatedValue = updatedRow.values.at(0)[cellDetail.CellDisplayIndex]?.toString().trim();
    const referenceData = cellDetail["referenceData"];
    const lookupDataAttribute = referenceData?.sourceDataObjectName;
    if (cellDetail?.["dataType"] == "richText") {
      updatedValue = Utility.convertNewLinesToParagraphs(updatedValue);
    }

    if (!Utility.isNullOrUndefined(lookupDataAttribute)) {
      let lookupData = data[lookupDataAttribute];
      if (cellDetail?.CellData?.["dataType"] == "listlookup" || cellDetail?.CellData?.["dataType"] == "list") {
        let delimiter = ";";
        if (cellDetail?.["referenceData"]?.delimiter) {
          delimiter = cellDetail?.["referenceData"]?.delimiter;
        }

        let cellDataUpdated = updatedValue?.split(delimiter).map((item) => item.trim());
        let updatedIds = cellDataUpdated.map((item) => {
          let lookupDataValue = lookupData[item];
          return lookupDataValue?.id ?? item;
        });

        updatedIds = updatedIds.filter((x) => x != null);
        requestPayload[payloadDataAttributeName] = updatedIds;
      } else {
        let lookupDataValue = lookupData?.find((x) => x.value == updatedValue);
        let updateValidValue = lookupDataValue?.id ? lookupDataValue?.id : lookupDataValue;

        requestPayload[payloadDataAttributeName] = updateValidValue;
        if (lookupDataValue && lookupDataValue?.parentId) {
          requestPayload[parentDataAttributeName] = lookupDataValue?.parentId;
        }
      }
    } else {
      requestPayload[payloadDataAttributeName + "value"] = updatedValue;
    }
  }

  private async getLookupItemRequestPayload(
    lookupDataValue,
    updatedValue,
    payloadOutputAttribute,
    cellDetail,
    requestPayload
  ) {
    let defaultPayloadValue = false;
    let apiPayloadValue = !Utility.isNullOrUndefined(lookupDataValue?.id) ? lookupDataValue?.id : lookupDataValue;
    if (Utility.isInvalidValue(apiPayloadValue)) {
      apiPayloadValue = updatedValue;
      if (payloadOutputAttribute?.defaultApiPayload) {
        if (!Utility.isNullOrUndefined(payloadOutputAttribute.defaultApiPayload?.invalidDefaultValue)) {
          // send invalid value to api instead of null if lookup does not have data and api can send error back if value is not in enum
          if (
            payloadOutputAttribute.defaultApiPayload?.validEmptyValue &&
            Utility.isInvalidValue(updatedValue?.toString()?.trim())
          ) {
            apiPayloadValue = "";
          } else {
            apiPayloadValue = payloadOutputAttribute.defaultApiPayload?.invalidDefaultValue;
          }
        } else if (!Utility.isNullOrUndefined(payloadOutputAttribute.defaultApiPayload.defaultValue)) {
          apiPayloadValue = payloadOutputAttribute.defaultApiPayload.defaultValue;
          defaultPayloadValue = true;
          if (payloadOutputAttribute.defaultApiPayload.resourceName) {
            let values = currentResource[payloadOutputAttribute.defaultApiPayload.resourceName];
            if (_.isArray(values)) {
              let labelValue = values.find((x) => x.value == payloadOutputAttribute.defaultApiPayload.defaultValue);
              requestPayload[payloadOutputAttribute.dataAttributeName + "value"] = labelValue
                ? labelValue.label
                : payloadOutputAttribute.defaultApiPayload.defaultValue;
            }
          }
        } else if (payloadOutputAttribute.defaultApiPayload?.isNullable) {
          apiPayloadValue = null;
        }
      }
    }

    let apiLookupPayload = {
      apiPayloadValue: apiPayloadValue,
      defaultPayloadValue: defaultPayloadValue,
    };
    return apiLookupPayload;
  }

  public async updateRequestPayload(
    updatedRow: Excel.TableRow,
    configuration: EntityConfiguration,
    data: any,
    requestPayload: any
  ) {
    let userLanguage = await Utility.getLanguageFromSettings(configuration);
    let apiTemplate = configuration.entityConfiguration["apiTemplate"];
    let rowDataUpdated = false;
    let validValueRequired = false;
    if (apiTemplate.updateMethodType == "POST") {
      validValueRequired = true;
    }
    for (let outputAttribute of apiTemplate.updateOutputAttributes.filter(
      (x) => x.idValueUpdatedInRequestOutput != true
    )) {
      let dataEdited = true;
      let apiLookupPayload = null;
      let cellDetail = configuration.columns.find((x) => x.CellId == outputAttribute.cellId);
      let compareValueAttributeName = "value";
      if (cellDetail?.referenceData?.getCellData) {
        compareValueAttributeName = "label";
      }

      // Cell data for the column that is getting used for payload value.
      let updatedValue = updatedRow.values.at(0)[cellDetail.CellDisplayIndex]?.toString().trim();

      // Cell data for the column that is getting used only for getting id based on comparsion with reference data in case of lookup data type value.
      const cellDataForLookup = updatedRow.values.at(0)[cellDetail.CellDisplayIndex]?.toString();
      
      /** Normalizes date strings from 'YYYY-M-D' to 'YYYY-MM-DD' before sending to the API.
      Example: 2026-5-3 -> 2026-05-03. API expects dates in 'YYYY-MM-DD' format. **/
      if (outputAttribute?.changeDateFormat === "YYYY-MM-DD" && updatedValue?.toString().trim()) {
        const [yearPart, monthPart, dayPart] = updatedValue.split("-").map((part) => part.trim());
        if (yearPart && monthPart && dayPart) {
          updatedValue = `${yearPart}-${monthPart.padStart(2, "0")}-${dayPart.padStart(2, "0")}`;
        }
      }


      if (outputAttribute.validateForNotSame) {
        let cellDetailOriginal = configuration.columns.find((x) => x.CellId == outputAttribute.originalCellId);
        let originalValue = updatedRow.values.at(0)[cellDetailOriginal.CellDisplayIndex].toString()?.trim();
        if (updatedValue == originalValue) {
          requestPayload[outputAttribute.dataAttributeName + "Edited"] = false;
          dataEdited = false;
          continue;
        }
      }

      const referenceData = cellDetail["referenceData"];
      const lookupDataAttribute = referenceData?.sourceDataObjectName;
      if (cellDetail?.["dataType"] == "richText") {
        updatedValue = Utility.convertNewLinesToParagraphs(updatedValue);
      }

      let referenceInputData = [];
      let lookupReferenceDataList = [];
      if (referenceData && Utility.isNullOrUndefined(lookupDataAttribute)) {
        referenceInputData = await Utility.getReferenceData(cellDetail, configuration, userLanguage);
      }

      if (
        (!Utility.isNullOrUndefined(lookupDataAttribute) || !_.isEmpty(referenceInputData)) &&
        outputAttribute.impactOnOtherCells &&
        updatedValue?.toString().trim()
      ) {
        let lookupReferenceData = referenceInputData;
        if (_.isEmpty(lookupReferenceData)) {
          lookupReferenceData = data[lookupDataAttribute];
        }
        const lookupDataImpactedValue = Utility.getLookupData(
          lookupReferenceData,
          updatedValue,
          compareValueAttributeName
        );
        //console.log("lookupDataImpactedValue", lookupDataImpactedValue);

        outputAttribute.impactOnOtherCells.forEach((impactCell) => {
          let impactedCellDetail = configuration.columns.find((x) => x.CellId == impactCell.cellId);
          let impactedCellValue = updatedRow.values.at(0)[impactedCellDetail.CellDisplayIndex].toString()?.trim();
          if (!impactedCellValue) {
            // if impacted cell does not have data then only update value
            // For e.g if time phase is updated and due date is blank then take value from timephase end date
            requestPayload[impactCell.dataAttributeName] =
              lookupDataImpactedValue?.[impactCell.valueProp] ?? impactCell?.defaultValue;
          }
        });
      }

      if ((!Utility.isNullOrUndefined(lookupDataAttribute) || !_.isEmpty(referenceInputData)) && dataEdited) {
        lookupReferenceDataList = referenceInputData;
        if (_.isEmpty(lookupReferenceDataList)) {
          lookupReferenceDataList = data?.[lookupDataAttribute];
        }
        if (cellDetail?.CellData?.["dataType"] == "listlookup" || cellDetail?.CellData?.["dataType"] == "list") {
          let updatedMultiSelectValue = updatedRow.values.at(0)[cellDetail.CellDisplayIndex]?.toString();
          let delimiter = "; ";
          if (cellDetail?.["referenceData"]?.delimiter) {
            delimiter = cellDetail?.["referenceData"]?.delimiter;
          }

          let cellDataUpdated = updatedMultiSelectValue ? updatedMultiSelectValue?.split(delimiter) : [];
          let updatedIds = cellDataUpdated.map((item) => {
            let lookupDataValue = Utility.getLookupData(lookupReferenceDataList, item, compareValueAttributeName);
            return !Utility.isNullOrUndefined(lookupDataValue?.id) ? lookupDataValue?.id : item;
          });

          updatedIds = updatedIds.filter((x) => x != null);
          requestPayload[outputAttribute.dataAttributeName] = updatedIds;
          if (outputAttribute.fetchValueFromOriginalCell) {
            // this data will be used to find what records needs to delete from database. For eg which EY contacts are deleted
            const cellDetailOriginal = configuration.columns.find((x) => x.CellId === outputAttribute.originalCellId);
            const valueOriginal = updatedRow.values.at(0)[cellDetailOriginal.CellDisplayIndex];
            let delimiter = "; ";
            if (cellDetail?.["referenceData"]?.delimiter) {
              delimiter = cellDetail?.["referenceData"]?.delimiter;
            }

            let cellDataOriginal = valueOriginal ? valueOriginal?.split(delimiter) : [];
            let idsOriginal = cellDataOriginal.map((item) => {
              let lookupDataValue = Utility.getLookupData(lookupReferenceDataList, item, compareValueAttributeName);
              return lookupDataValue?.id;
            });

            idsOriginal = idsOriginal.filter((x) => x != null);
            requestPayload[outputAttribute.dataAttributeName + "OriginalIds"] = idsOriginal;
          }
        } else {
          let lookupDataValue = Utility.getLookupData(
            lookupReferenceDataList,
            cellDataForLookup,
            compareValueAttributeName
          );

          apiLookupPayload = await this.getLookupItemRequestPayload(
            lookupDataValue,
            cellDataForLookup,
            outputAttribute,
            cellDetail,
            requestPayload
          );

          requestPayload[outputAttribute.dataAttributeName] = apiLookupPayload.apiPayloadValue;

          if (referenceData?.parentDataAttributeId) {
            let parentAttribute = apiTemplate.updateOutputAttributes.find(
              (x) => x.cellId == referenceData?.parentDataAttributeId
            );
            if (parentAttribute) {
              let cellDetailParent = configuration.columns.find((x) => x.CellId == parentAttribute?.cellId);
              let cellDataValue = updatedRow.values.at(0)[cellDetailParent.CellDisplayIndex].toString();
              if (lookupDataValue?.toString().trim()) {
                // check if parent cell already has some value then no need to update value based on child data because validation will through error
                requestPayload[parentAttribute.dataAttributeName] = lookupDataValue?.parentId
                  ? lookupDataValue?.parentId
                  : lookupDataValue;
              }
              // else {
              //   // update value for parent because child can't save without parent
              //   const referenceDataParent = cellDetailParent["referenceData"];
              //   const lookupDataAttributeParent = referenceDataParent?.sourceDataObjectName;
              //   let lookupDataParent = data[lookupDataAttributeParent];
              //   const lookupDataValueParent = Utility.getLookupData(
              //     lookupDataParent,
              //     cellDataValue,
              //     compareValueAttributeName
              //   );
              //   requestPayload[parentAttribute.dataAttributeName] = lookupDataValueParent?.id
              //     ? lookupDataValueParent?.id
              //     : lookupDataValueParent;
              // }
            }
          }
        }

        if (apiLookupPayload && apiLookupPayload?.defaultPayloadValue) {
          //
        } else {
          requestPayload[outputAttribute.dataAttributeName + "value"] = updatedValue;
        }

        if (outputAttribute.groupedRelatedDataAttribute) {
          await this.updateRequestPayloadBasedOnCellId(
            outputAttribute.groupedRelatedDataAttribute.cellId,
            outputAttribute.groupedRelatedDataAttribute.dataAttributeName,
            updatedRow,
            configuration,
            requestPayload,
            data,
            outputAttribute.dataAttributeName
          );
        }
        rowDataUpdated = true;
      } else {
        if (cellDetail && dataEdited) {
          if (Utility.isNullOrUndefined(updatedValue)) {
            updatedValue = "";
          }
          if (
            outputAttribute.defaultApiPayload?.isNullable &&
            Utility.isInvalidValue(updatedValue?.toString()?.trim())
          ) {
            // cells without reference data, for e.g dates, send null so that api clears the value instead of rejecting empty text
            updatedValue = null;
          }
          if (validValueRequired) {
            if (!Utility.isInvalidValue(updatedValue)) {
              requestPayload[outputAttribute.dataAttributeName] = updatedValue;
            }
          } else {
            requestPayload[outputAttribute.dataAttributeName] = updatedValue;
          }

          rowDataUpdated = true;
        }
      }
    }
    if (rowDataUpdated) {
      requestPayload["editRowIndex"] = updatedRow.index;
    }
  }

  async validateInputData(
    updatedRows: Array<Excel.TableRow>,
    configuration: EntityConfiguration,
    enableValidation: boolean
  ): Promise<any> {
    let modifiedRequests: Array<any> = new Array<any>();
    let duplicateInputData = Array<string>();
    let userLanguage = await Utility.getLanguageFromSettings(configuration);
    let validationFail = false;
    let inputValidationRule = configuration.entityConfiguration["inputValidationRule"];
    let duplicateValidationCells = Array<any>();
    if (inputValidationRule?.dupliateOutputData) {
      inputValidationRule.dupliateOutputData.forEach((rule) => {
        let cellDetail = configuration.columns.find((x) => x.CellId == rule.cellId);
        if (cellDetail) {
          duplicateValidationCells.push(cellDetail);
        }
      });
    }

    if (_.size(duplicateValidationCells) > 0) {
      {
        updatedRows.forEach((updatedRow: Excel.TableRow) => {
          let concategatedName = "";
          duplicateValidationCells.forEach((cellDetail) => {
            concategatedName = concategatedName + updatedRow.values.at(0)[cellDetail.CellDisplayIndex] + "_";
          });
          duplicateInputData.push(concategatedName);
        });
      }
    }

    let refrenceData = {};

    await this.loadReferenceData(configuration, userLanguage, refrenceData);

    for (let i = 0; i < updatedRows.length; i++) {
      const updatedRow = updatedRows[i];
      let validationStatus = enableValidation
        ? await this.ValidateInputValues(updatedRow, configuration, duplicateInputData, refrenceData, userLanguage)
        : null;

      let requestPayload = {};
      if (!_.isNull(validationStatus)) {
        if (validationStatus?.hasSameName) {
          requestPayload["uploadStatus"] = UploadStatus.Uploaded;
          requestPayload["isSameName"] = true;
        } else {
          requestPayload["uploadError"] = validationStatus;
          requestPayload["uploadStatus"] = UploadStatus.InvalidInput;
          validationFail = true;
        }
      } else {
        requestPayload["uploadStatus"] = UploadStatus.Pending;
      }

      // Create payload only if validation is successful
      // if (!validationFail) {
      // if validation fail then no need to update request payload, request payload will be used to send
      await this.updateRequestPayload(updatedRow, configuration, refrenceData, requestPayload);
      // }
      // will have to put one more validation rule for dupliate
      // let duplicateRequest = modifiedRequests.find(
      //   (s) => s.documentName == updatedDocumentName && s.fileExt == fileExt
      // );
      // if (duplicateRequest) {
      //   request.duplicateDocument = true;
      //   duplicateRequest.duplicateDocument = true;
      // }
      modifiedRequests.push(requestPayload);
    }
    return { validationFail, modifiedRequests, refrenceData };
  }

  async populateReferenceSheetAsync(
    rowsDataModel: ServiceDataModel,
    masterSheet: Excel.Worksheet,
    context: Excel.RequestContext,
    masterSheetName: string,
    configuration: any
  ): Promise<any> {
    const referenceData = rowsDataModel.referenceData;
    await Excel.run(async (context) => {
      let sheet = context.workbook.worksheets.getItem(masterSheetName);
      for (const column of configuration.referenceSheetColumns) {
        let cellRange: Excel.Range;
        if (column.DisplayCell) {
          cellRange = sheet.getRange(column.DisplayCell);
          cellRange.values = [[column.CellHeader]];
        } else if (column.MergeDisplayCells) {
          cellRange = sheet.getRange(column.MergeDisplayCells);
          // Merge the cells
          cellRange.merge(true);
          await context.sync();

          const [startCell, endCell] = column.MergeDisplayCells.split(":");
          let valueRange = sheet.getRange(startCell);

          // Populate the merged cells with the value of cellHeader
          valueRange.values = [[column.cellHeader]];
        }
        // Apply formatting
        cellRange.format.horizontalAlignment = "Center";
        cellRange.format.verticalAlignment = "Bottom";
        cellRange.format.font.bold = true;
        cellRange.format.fill.color = ExcelColorValue.GrayColor;

        if (column.SubheaderDetails) {
          const subHeaderRange = column.SubheaderDetails.SubHeaderDisplayCells;
          const subHeaders = column.SubheaderDetails.SubHeaders;
          const referenceDataArray = referenceData[column.SubheaderDetails.DataAttribute];
          const startCell = column.SubheaderDetails.DisplayCellDisplayCellStartingCell;

          // Get the range for the subheaders
          const subHeaderCells = sheet.getRange(subHeaderRange);

          // Populate the subheaders into the range
          subHeaderCells.values = [subHeaders];

          // Apply formatting
          subHeaderCells.format.horizontalAlignment = "General";
          subHeaderCells.format.verticalAlignment = "Bottom";
          subHeaderCells.format.font.bold = true;

          if (referenceDataArray.length) {
            // Calculate the starting column and row
            const startColumn = startCell[0];
            const startRow = parseInt(startCell.slice(1), 10);
            // Calculate the ending column based on SubHeaders length
            const endingColumn = String.fromCharCode(startColumn.charCodeAt(0) + subHeaders.length - 1); // "F"

            // Calculate the ending row based on referenceData length
            const endingRow = startRow + referenceDataArray.length - 1; // e.g., 5 + 5 - 1 = 10

            // Define the range to populate
            const rangeToPopulate = `${startCell}:${endingColumn}${endingRow}`; // e.g., "C5:F10"

            // Get the range in the worksheet
            const dataRange = sheet.getRange(rangeToPopulate);

            // Populate the data into the range
            dataRange.values = referenceDataArray;

            if (column.SubheaderDetails.SubHeadsersFormatting) {
              if (column.SubheaderDetails.SubHeadsersFormatting.Horizontalallignment) {
                const alignments = column.SubheaderDetails.SubHeadsersFormatting.Horizontalallignment;

                //Iterate over each alignment type (e.g., Left, Right, Center)
                for (const [alignment, columns] of Object.entries(alignments)) {
                  for (const col of columns as string[]) {
                    const range = sheet.getRange(`${col}${startRow}:${col}${endingRow}`); // Target the entire column
                    range.format.horizontalAlignment = alignment as Excel.HorizontalAlignment; // Apply the alignment dynamically
                  }
                }
              }
            }
          }
        }

        if (column.ReduceWidthForColumn) {
          let columnToReduceWidth = column.ReduceWidthForColumn;
          let columnRange = sheet.getRange(`${columnToReduceWidth}:${columnToReduceWidth}`);
          columnRange.format.columnWidth = 10;
        }

        sheet.getUsedRange().format.autofitColumns();
        sheet.getUsedRange().format.autofitRows();

        await ExcelHelper.tryCatchContextSync(context, `population completed for sheet ${masterSheetName}`);
      }
    });
  }

  async populateInstructionSheetAsync(
    rowsDataModel: ServiceDataModel,
    masterSheet: Excel.Worksheet,
    context: Excel.RequestContext,
    masterSheetName: string,
    configuration: any,
    triggerTemplate: boolean = false
  ): Promise<any> {
    const instructionSheetData = currentResource.instructionSheetData;

    let instructionStaticDataCells =
      configuration.entityConfiguration["instructionSheetConfigurations"]?.["instructionstaticdatacells"];

    await this.populateStaticData(masterSheet, instructionStaticDataCells, configuration);
    let instrctionSheetTableConfiguration =
      configuration.entityConfiguration["instructionSheetConfigurations"]?.["instrctionSheetTableConfiguration"];

    let data = undefined;

    if (rowsDataModel?.referenceData?.["instructionData"]) {
      data = rowsDataModel?.referenceData["instructionData"];
    }
    if (instrctionSheetTableConfiguration?.tableResourceName && !data) {
      data = currentResource[instrctionSheetTableConfiguration.tableResourceName];
    }
    currentResource.instructionSheetTabularData;
    instrctionSheetTableConfiguration &&
      (await TemplateUIExcelInterface.populateTabularData(
        masterSheet,
        data,
        instrctionSheetTableConfiguration,
        configuration,
        context
      ));

    await context.sync();

    //Work with the top-left cell of the merged range
    let instrctionSheetHeightAdjustment =
      configuration.entityConfiguration["instructionSheetConfigurations"]?.["adjustmentOfHeightForMergedCells"];
    if (instrctionSheetHeightAdjustment) {
      for (let i = 0; i < instrctionSheetHeightAdjustment.length; i++) {
        let numberOfLines = 0;
        let topLeftCell = masterSheet.getRange(instrctionSheetHeightAdjustment[i].mergedCell);
        topLeftCell.load("text");
        await context.sync();
        const text = topLeftCell.text[0];
        if (instrctionSheetHeightAdjustment[i].verticalMerge) {
          numberOfLines = text[0].split("\n").length - 1;
        } else {
          const textLength = text[0].length;
          let referencLength = instrctionSheetHeightAdjustment[i].referenceCharacterInOneLine;
          numberOfLines = Math.ceil(textLength / referencLength);
        }
        topLeftCell.format.rowHeight = 15 * numberOfLines;
        await context.sync();
      }
    }

    //To override the border
    let borderToOverrideEdge =
      configuration.entityConfiguration["instructionSheetConfigurations"]?.["overRideEdgeBorder"];
    if (borderToOverrideEdge) {
      for (let i = 0; i < borderToOverrideEdge.length; i++) {
        const cellToOverride = masterSheet.getRange(borderToOverrideEdge[i].cell);
        cellToOverride.format.borders.getItem(borderToOverrideEdge[i].edge).style = Excel.BorderLineStyle.none;
      }
    }

    await context.sync();
    // masterSheet.getUsedRange().format.autofitColumns();
    // masterSheet.getUsedRange().format.autofitRows();
  }

  async loadReferenceData(configuration: any, userLanguage: string, data: any = {}) {
    let dropDownbindedCells = configuration.entityConfiguration.columns.filter((x) => x.referenceData);
    for (let cellDetail of dropDownbindedCells) {
      let dataObject: Promise<any> = null;
      let compareValueAttributeName = "value";
      if (cellDetail?.referenceData?.getCellData) {
        dataObject = cellDetail.referenceData.getCellData(userLanguage);
        compareValueAttributeName = "label";
      } else if (
        cellDetail != null &&
        cellDetail?.referenceData &&
        cellDetail.referenceData.referenceDataCellNameStartAddress
      ) {
        dataObject = await TemplateUIExcelInterface.getDataFromSheet(
          Constants.MasterWorkSheetPrefix,
          cellDetail,
          cellDetail.referenceData.referenceDataCellNameStartAddress,
          cellDetail.referenceData?.referenceDataCellNameEndAddress,
          cellDetail.referenceData?.referenceDataCellRowStartIndex,
          cellDetail.referenceData?.referenceDataCellRowIndexMax,
          cellDetail.referenceData.outputDataattributes,
          configuration
        );
      }
      data[cellDetail.CellId + "referenceData"] = dataObject;
    }
  }

  async updateWorksheetAfterUpload(
    context: Excel.RequestContext,
    sheet: Excel.Worksheet,
    existingRequestsTable: Excel.Table,
    uploadedRequests: Array<any>,
    configuration,
    referenceSheetData: Object
  ): Promise<any> {
    let apiTemplate = configuration.entityConfiguration["apiTemplate"];
    let recalculatedRows = new Array();

    const isExtraAPICallRequired = configuration.entityConfiguration["apiTemplate"]?.["additionalAPICallRequired"];

    const allowPartialUpdate = isExtraAPICallRequired ? true : false;

    if (!allowPartialUpdate) {
      // For Documents with atleast for error object in batch,
      // no record will be uploaded hence the status of records with out error should be pending only.
      // records with error will be marked as upload error.

      let errorFound = uploadedRequests.find((record) => {
        return !_.isEmpty(record.uploadError);
      });

      if (!_.isEmpty(errorFound)) {
        uploadedRequests = uploadedRequests.filter((x) => x.uploadStatus != UploadStatus.Uploaded);
      }
    }

    const UploadStatusCellName = configuration.getAttributeExcelCellName(
      configuration.columns,
      ColumnType.UploadStatus
    );
    const UploadStatusIdCellName = configuration.getAttributeExcelCellName(
      configuration.columns,
      ColumnType.UploadStatusId
    );
    const MarkForUpdateCellName = configuration.getAttributeExcelCellName(
      configuration.columns,
      ColumnType.MarkForUpdate
    );
    const EndingDataColumnCellName = configuration.getEndingDataExcelCellName(configuration.columns);
    _.forEach(uploadedRequests, (uploadedRequest: any) => {
      const uploadedRowRangeIndex = uploadedRequest.editRowIndex + CommonConfiguration.dataStartingRowIndex;
      let uploadedRowRange: Excel.Range = sheet.getRange(
        `${CommonColumn.BeginningColumn}${uploadedRowRangeIndex}:${EndingDataColumnCellName}${uploadedRowRangeIndex}`
      );
      let uploadStatusColumnRange: Excel.Range = sheet.getRange(
        `${UploadStatusCellName}${uploadedRowRangeIndex}:${UploadStatusCellName}${uploadedRowRangeIndex}`
      );
      let uploadStatusIdColumnRange: Excel.Range = sheet.getRange(
        `${UploadStatusIdCellName}${uploadedRowRangeIndex}:${UploadStatusIdCellName}${uploadedRowRangeIndex}`
      );
      let markForUpdateColumnRange: Excel.Range = sheet.getRange(
        `${MarkForUpdateCellName}${uploadedRowRangeIndex}:${MarkForUpdateCellName}${uploadedRowRangeIndex}`
      );
      let rowColor: string = "";
      switch (uploadedRequest.uploadStatus) {
        case UploadStatus.Uploaded:
          // eslint-disable-next-line no-case-declarations

          markForUpdateColumnRange.values = [[Constants.MarkForUpdateNo]];
          uploadStatusColumnRange.format.protection.locked = false;
          uploadStatusIdColumnRange.format.protection.locked = false;
          uploadStatusColumnRange.values = [[currentResource.uploadStatusLabels[uploadedRequest.uploadStatus]]];
          uploadStatusIdColumnRange.values = [[uploadedRequest.uploadStatus]];
          apiTemplate.updateOutputAttributes
            .filter((x) => x.updateValueInOriginalCell || x.updateValueFromPayload)
            .forEach((outputAttribute) => {
              if (
                TemplateUIExcelInterface.isCellUpdateRequired(
                  outputAttribute.dataAttributeName,
                  uploadedRequest,
                  outputAttribute.updateValueFromPayload,
                  outputAttribute.updateValueInOriginalCell
                )
              ) {
                let originalCellDetail = configuration.columns.find((x) => x.CellId == outputAttribute.originalCellId);
                let updatedCellDetail = configuration.columns.find((x) => x.CellId == outputAttribute.cellId);
                if (originalCellDetail) {
                  TemplateUIExcelInterface.updateDataInCellBasedOnPayload(
                    originalCellDetail,
                    sheet,
                    uploadedRowRangeIndex,
                    configuration,
                    outputAttribute,
                    uploadedRequest,
                    context,
                    true
                  );

                  if (outputAttribute.impactOnOtherCells) {
                    recalculatedRows.push(uploadedRowRangeIndex);
                  }
                }
                if (updatedCellDetail && outputAttribute.updateValueFromPayload) {
                  TemplateUIExcelInterface.updateDataInCellBasedOnPayload(
                    updatedCellDetail,
                    sheet,
                    uploadedRowRangeIndex,
                    configuration,
                    outputAttribute,
                    uploadedRequest,
                    context,
                    false
                  );
                }
                // if (recalculateHash) {
                // To Do throughing error here for context sync
                //ExcelUtilityHelper.recalculateHashvalue(uploadedRowRangeIndex, sheet, context, configuration);
                //}
              }
            });

          uploadStatusColumnRange.format.protection.locked = true;
          uploadStatusIdColumnRange.format.protection.locked = true;
          rowColor = ExcelColorValue.Green;

          if (apiTemplate.updateMethodType == "POST") {
            const uploadedRowRangeIndex = uploadedRequest.editRowIndex + CommonConfiguration.dataStartingRowIndex;
            let uploadedRowRange: Excel.Range = sheet.getRange(
              `${CommonColumn.BeginningColumn}${uploadedRowRangeIndex}:${EndingDataColumnCellName}${uploadedRowRangeIndex}`
            );
            uploadedRowRange.format.protection.locked = true;
          }

          break;
        case UploadStatus.ClientFetchError:
        case UploadStatus.InvalidInput:
        case UploadStatus.ServerError:
        case UploadStatus.UnexpectedAPIError:
        case UploadStatus.PostProcessingStepsError:
          markForUpdateColumnRange.values = [[Constants.MarkForUpdateNo]];
          uploadStatusColumnRange.format.protection.locked = false;
          uploadStatusIdColumnRange.format.protection.locked = false;
          uploadStatusColumnRange.values = [[uploadedRequest.uploadError]];
          uploadStatusIdColumnRange.values = [[uploadedRequest.uploadError]];
          uploadStatusColumnRange.format.protection.locked = true;
          uploadStatusIdColumnRange.format.protection.locked = true;
          rowColor = ExcelColorValue.Red;

          if (
            apiTemplate.updateMethodType == "POST" &&
            uploadedRequest.uploadStatus == UploadStatus.PostProcessingStepsError
          ) {
            const uploadedRowRangeIndex = uploadedRequest.editRowIndex + CommonConfiguration.dataStartingRowIndex;
            let uploadedRowRange: Excel.Range = sheet.getRange(
              `${CommonColumn.BeginningColumn}${uploadedRowRangeIndex}:${EndingDataColumnCellName}${uploadedRowRangeIndex}`
            );
            uploadedRowRange.format.protection.locked = true;
          }

          break;
        case UploadStatus.Pending:
          rowColor = ExcelColorValue.Yellow;
          break;
        default:
          break;
      }
      if (_.isEmpty(rowColor)) {
        uploadedRowRange.format.fill.clear();
      } else {
        uploadedRowRange.format.fill.color = rowColor;
      }
    });

    return recalculatedRows;
  }

  public static isCellUpdateRequired = (
    dataAttributeName,
    uploadedRequest,
    updateValueFromPayload,
    updateValueInOriginalCell = false
  ) => {
    if (uploadedRequest.hasOwnProperty(`${dataAttributeName}value`)) {
      return true;
    }
    if (uploadedRequest.hasOwnProperty(dataAttributeName) && (updateValueFromPayload || updateValueInOriginalCell)) {
      return true;
    }
    return false;
  };

  public static updateDataInCellBasedOnPayload = async (
    cellDetail,
    sheet,
    uploadedRowRangeIndex,
    configuration,
    outputAttribute,
    uploadedRequest,
    context,
    originalCells
  ) => {
    let isProtectedColumn = false;
    const cell = CellIndexMapping[cellDetail.CellDisplayIndex];
    const cellColumnRange: Excel.Range = sheet.getRange(
      `${cell}${uploadedRowRangeIndex}:${cell}${uploadedRowRangeIndex}`
    );
    if (originalCells) {
      cellColumnRange.format.protection.locked = false;
      isProtectedColumn = true;
    }

    const updatedCellDetail = configuration.columns.find((x) => x.CellId == outputAttribute.cellId);
    const { referenceData, dataType } = updatedCellDetail || {};
    const lookupDataAttribute = referenceData?.sourceDataObjectName || referenceData?.getCellData;
    const dataAttributeName = outputAttribute.dataAttributeName;

    if (outputAttribute.groupedRelatedDataAttribute) {
      const relatedDataAttribute = outputAttribute.groupedRelatedDataAttribute.dataAttributeName;

      if (
        (uploadedRequest.hasOwnProperty(relatedDataAttribute) ||
          uploadedRequest.hasOwnProperty(`${relatedDataAttribute}value`)) &&
        !uploadedRequest.hasOwnProperty(`${dataAttributeName}value`)
      )
        return;
    }

    if (lookupDataAttribute && uploadedRequest.hasOwnProperty(`${dataAttributeName}value`)) {
      cellColumnRange.values = [[uploadedRequest[`${dataAttributeName}value`]]];
    } else if (dataType === "richText" && uploadedRequest.hasOwnProperty(dataAttributeName)) {
      const formattedData = Utility.getFormatedDescriptionToExcelFormat(uploadedRequest[dataAttributeName]);
      cellColumnRange.values = [[formattedData]];
      cellColumnRange.format.wrapText = true;
    } else if (uploadedRequest.hasOwnProperty(dataAttributeName)) {
      cellColumnRange.values = [[uploadedRequest[dataAttributeName]]];
    }

    if (isProtectedColumn) {
      cellColumnRange.format.protection.locked = true;
    }
  };

  public static async getDataFromSheet(
    sheetName,
    columnInfo,
    dataCellNameStartAddress,
    dataCellNameEndAddress,
    dataCellRowStartIndex,
    dataCellRowIndexMax = 500,
    outputDataattributes,
    configuration
  ): Promise<any> {
    let sheetMissing = true;
    let dataObject = {};
    let valueObjects = [];
    await Excel.run(async (context) => {
      let dataSheet = context.workbook.worksheets.getItemOrNullObject(sheetName);
      await context.sync();
      // if ref sheet not present flag refrenceSheetMissing =true
      if (dataSheet.isNullObject) {
        // sheet not available
      } else {
        let cellNameStartAddress = dataCellNameStartAddress;
        let cellNameEndAddress = dataCellNameEndAddress;
        cellNameEndAddress = cellNameEndAddress ? cellNameEndAddress : cellNameStartAddress;

        // not require any additional binding in input sheet
        let rowIndexStartAddress = dataCellRowStartIndex;

        let rowIndexEndAddress = dataCellRowIndexMax ? dataCellRowIndexMax : 500;

        let dataValuesRange: Excel.Range = dataSheet.getRange(
          `${cellNameStartAddress}${rowIndexStartAddress}:$${cellNameEndAddress}${rowIndexEndAddress}`
        );

        var usedRange = dataValuesRange.getUsedRangeOrNullObject();

        await context.sync();
        if (!usedRange.isNullObject) {
          usedRange.load("values");

          await ExcelHelper.tryCatchContextSync(context, `Fetching data`);

          // Load the values property
          dataObject = usedRange.values;

          Object.keys(dataObject).forEach((element) => {
            if (_.isArray(dataObject[element])) {
              let valuesArray = dataObject[element];
              let dataObj = {};
              if (outputDataattributes) {
                outputDataattributes.forEach((item, index) => {
                  dataObj[item] = valuesArray[index];
                });
              } else {
                dataObj["value"] = valuesArray[0];
              }
              valueObjects.push(dataObj);
            }
          });

          sheetMissing = false;
        }
      }
    });
    return valueObjects;
  }

  async doChangesWhenChangingUpdateEYCanvas(
    context: Excel.RequestContext,
    sheet: Excel.Worksheet,
    firstUpdatedRowIndex: number,
    lastUpdatedRowIndex: number,
    configuration: EntityConfiguration,
    endingDataColumnCellName: string,
    markForUpdateCellName: string,
    uploadStatusCellName: string,
    uploadStatusIdCellName: string
  ): Promise<any> {
    for (let i: number = firstUpdatedRowIndex; i <= lastUpdatedRowIndex; i++) {
      let updateRowRange = sheet.getRange(`${CommonColumn.BeginningColumn}${i}:${endingDataColumnCellName}${i}`);
      updateRowRange.load("values");
      await ExcelHelper.tryCatchContextSync(context, `mark for update load ${markForUpdateCellName}${i}`);
      const markForUpdateValue = updateRowRange.values.at(0)?.[CommonColumn.markUpdateValue];

      if (_.isEqual(Constants.MarkForUpdateYes, markForUpdateValue)) {
        await ExcelUtilityHelper.doMarkForUpdateRangeFormatChanges(
          context,
          sheet,
          firstUpdatedRowIndex,
          lastUpdatedRowIndex,
          CommonColumn.BeginningColumn,
          endingDataColumnCellName,
          configuration
        );
        ExcelUtilityHelper.doUploadStatusValueAndFormatChanges(
          sheet,
          i,
          UploadStatus.Pending,
          uploadStatusCellName,
          uploadStatusIdCellName
        );
      } else if (_.isEqual(Constants.MarkForUpdateNo, markForUpdateValue)) {
        await ExcelUtilityHelper.doMarkForUpdateRangeFormatChanges(
          context,
          sheet,
          firstUpdatedRowIndex,
          lastUpdatedRowIndex,
          CommonColumn.BeginningColumn,
          endingDataColumnCellName,
          configuration,
          ""
        );
        ExcelUtilityHelper.doUploadStatusValueAndFormatChanges(
          sheet,
          i,
          UploadStatus.Downloaded,
          uploadStatusCellName,
          uploadStatusIdCellName
        );
      }
      // else, do nothing
    }
    await ExcelHelper.tryCatchContextSync(
      context,
      `single cell update mark row yellow dirty fromRow: ${firstUpdatedRowIndex} : toRow: ${lastUpdatedRowIndex}`
    );
  }

  async applyFormattingOnLoad(
    activeSheet: Excel.Worksheet,
    beginDataRowIndex: number,
    endDataRowIndex: number,
    configuration,
    requestsModel: ServiceDataModel
  ): Promise<any> {
    await ExcelHelper.tryCatchRunAsync(async (context) => {
      let columns = configuration.columns.filter((x) => x.CellFormat?.lockedCondition);
      for (let colIdx = 0; colIdx < columns.length; colIdx++) {
        const column = columns[colIdx];
        let cellName = CellIndexMapping[column.CellDisplayIndex];
        for (let i = 0; i < requestsModel.response.length; i++) {
          let value;
          let data = requestsModel.response[i];
          if (data) {
            // If lockedCondition is a function, call it; otherwise, access the property
            if (typeof column.CellFormat?.lockedCondition === "function") {
              value = column.CellFormat.lockedCondition(data);
            } else if (column.CellFormat?.lockedCondition?.dataAttributeName) {
              value = data[column.CellFormat.lockedCondition.dataAttributeName];
            }
            let rowIndex = beginDataRowIndex + i;
            let cellRange = activeSheet.getRange(`${cellName}${rowIndex}:${cellName}${rowIndex}`);
            if (value) {
              cellRange.format.protection.locked = true;
              cellRange.format.fill.color = ExcelColorValue.GrayColor;
            }
          }
        }
        await ExcelHelper.tryCatchContextSync(context, `formatting done`);
      }
    }, `formatting done`);
  }
  public static getCellDataBasedOnConfig = (cell: any) => {
    let data = "";
    let resourceData = labels;
    if (cell.CellData?.resourceName) {
      resourceData = currentResource[cell.CellData?.resourceName];
    }
    if (cell.CellData?.resourceKey) {
      data = resourceData[cell.CellData?.resourceKey];
      return data;
    }
    if (cell.CellData?.value != undefined) {
      data = cell.CellData?.value;
    }

    return data;
  };

  populateStaticData = (
    masterSheet: Excel.Worksheet,
    staticDataCellsConfiguration: any,
    configuration: EntityConfiguration
  ): any => {
    if (staticDataCellsConfiguration) {
      staticDataCellsConfiguration.forEach((cell) => {
        let startRangeIndex, endRangeIndex;
        let cellRange: Excel.Range;
        if (cell.cellMergedRange) {
          const [startCell, endCell] = cell.cellMergedRange.split(":");
          startRangeIndex = CellIndexMapping.indexOf(startCell[0]);
          endRangeIndex = CellIndexMapping.indexOf(endCell[0]);
          cellRange = masterSheet.getRange(cell.cellMergedRange);
          cellRange.merge(true);
        } else {
          startRangeIndex = endRangeIndex = 0;
          cellRange = masterSheet.getRange(cell.cellRange);
        }

        let data = TemplateUIExcelInterface.getCellDataBasedOnConfig(cell);
        let headerValues = new Array(endRangeIndex - startRangeIndex + 1).fill("");
        headerValues[0] = data;
        cellRange.values = [headerValues];

        if (cell?.CellFormat?.HeaderBorderStyle && cell?.CellFormat?.HeaderBorderColor) {
          ExcelUtilityHelper.drawBorderForCell(
            cellRange,
            cell.CellFormat.HeaderBorderStyle,
            cell.CellFormat.HeaderBorderColor
          );
        }
        if (cell?.CellFormat?.horizontalAlignment) {
          cellRange.format.horizontalAlignment = cell?.CellFormat?.horizontalAlignment;
        }
        if (cell?.CellFormat?.VerticalAlignment) {
          cellRange.format.verticalAlignment = cell?.CellFormat?.VerticalAlignment;
        }
        if (cell?.CellFormat?.wrapText) {
          cellRange.format.wrapText = true;
        }
        if (cell?.CellFormat?.bold) {
          cellRange.format.font.bold = true;
        }

        if (cell.CellFormat.FillColor) {
          cellRange.format.fill.color = cell.CellFormat.FillColor;
        }
        if (cell.CellFormat.FontColor) {
          cellRange.format.font.color = cell.CellFormat.FontColor;
        }

        if (cell?.CellFormat?.hyperlink) {
          const hyperlink = {
            address: Environment.getConfigUrl(cell.CellFormat.hyperlink.dataAttributeName),
            textToDisplay: data,
          };
          cellRange.hyperlink = hyperlink;
        }
      });
    }
  };

  public static populateTabularData = (
    masterSheet: Excel.Worksheet,
    dataRows: any,
    tableConfiguration: any,
    configuration: EntityConfiguration,
    context: Excel.RequestContext
  ): any => {
    this.applyFormatingOnRows(
      masterSheet,
      tableConfiguration.dataRowStartIndex,
      tableConfiguration.dataRowStartIndex + (dataRows.length - 1),
      tableConfiguration.headerRowStartIndex,
      tableConfiguration.columns,
      configuration,
      context,
      true
    );
    let startRowIndex = tableConfiguration.headerRowStartIndex;
    const EndingDataColumnCellName = Utility.getEndingDataExcelCellName(tableConfiguration.columns);
    let headerRow = this.getHeaderDataRow(tableConfiguration.columns);

    const startDataColumnCellName = Utility.getStartingDataExcelCellName(tableConfiguration.columns);
    let cellRange: Excel.Range = masterSheet.getRange(
      `${startDataColumnCellName}` + startRowIndex + `:${EndingDataColumnCellName}` + startRowIndex
    );
    cellRange.values = [headerRow];

    startRowIndex = tableConfiguration.dataRowStartIndex;
    dataRows.forEach((dataRow, index) => {
      let rowData = this.getDataRow(tableConfiguration.columns, dataRow, configuration, {}, {});
      let cellRange: Excel.Range = masterSheet.getRange(
        `${startDataColumnCellName}` + startRowIndex + `:${EndingDataColumnCellName}` + startRowIndex
      );
      cellRange.values = [rowData];
      if (index !== dataRows.length - 1) {
        startRowIndex++;
      }
    });
    this.applyFormatingOnRows(
      masterSheet,
      tableConfiguration.dataRowStartIndex,
      startRowIndex,
      tableConfiguration.headerRowStartIndex,
      tableConfiguration.columns,
      configuration,
      context
    );
  };

  async boundSheetDropDownBinding(
    masterSheet: Excel.Worksheet,
    context: Excel.RequestContext,
    noOfDataRows: string,
    additionalReferenceSheetBindingInformation: any[],
    configuration: EntityConfiguration,
    inputBoundSheet: Excel.Worksheet
  ) {
    let userLanguage = await Utility.getLanguageFromSettings(configuration);
    let columnsToBind = configuration.columns.filter((cl) => cl.cellToBindDropDown);
    for (const column of columnsToBind) {
      let dataToShowInDropDown: Excel.Range | string = "";
      let excelCell = CellIndexMapping[column.CellDisplayIndex];
      let columnDataRangeValues: String = `${excelCell}${CommonConfiguration.dataStartingRowIndex}:${excelCell}${
        noOfDataRows + 1
      }`;
      let markUpdateColumnDataRange: Excel.Range = inputBoundSheet.getRange(`${columnDataRangeValues}`);
      //To bind static columns
      if (column["referenceData"]?.getCellData) {
        let referenceInputData = await Utility.getReferenceData(column, configuration, userLanguage);
        dataToShowInDropDown = referenceInputData.map((x) => x.label).join(",");
      }
      //To bind column that is getting data from reference sheet
      else if (column["referenceData"]?.referenceDataCellNameStartAddress) {
        const bindingColumn = column["referenceData"]?.referenceDataCellNameStartAddress;
        const bindingStartingRowIndex = column["referenceData"]?.referenceDataCellRowStartIndex;
        const bindingEndingRowIndex = column["referenceData"]?.referenceDataCellRowIndexMax;
        const referenceSheetRange = masterSheet.getRange(
          `${bindingColumn}${bindingStartingRowIndex}:${bindingColumn}${bindingEndingRowIndex}`
        ); // Start from the specified cell

        // Get the used range starting from the specified cell
        const usedRange = referenceSheetRange.getUsedRangeOrNullObject();
        usedRange.load("values");
        await ExcelHelper.tryCatchContextSync(context, `Data binding for ${column}`);
        if (!usedRange.isNullObject) {
          // Check if there are values in the range
          const values = usedRange.values;
          if (values && values.length > 0) {
            // Flatten the values and join with comma for dropdown
            dataToShowInDropDown = usedRange;
          } else {
            dataToShowInDropDown = "";
          }
        } else {
          dataToShowInDropDown = "";
        }
      }
      markUpdateColumnDataRange.dataValidation.clear();
      markUpdateColumnDataRange.dataValidation.rule = {
        list: {
          inCellDropDown: true,
          source: dataToShowInDropDown,
        },
      };
    }

    const columnForInputMessage = configuration.columns.filter((cl) => cl?.referenceData?.showDynamicDropdown);
    for (const column of columnForInputMessage) {
      let cellName = CellIndexMapping[column.CellDisplayIndex];
      let columnDataRangeValues: String = `${cellName}${CommonConfiguration.dataStartingRowIndex}:${cellName}${
        noOfDataRows + 1
      }`;
      let inputMessageDataRange: Excel.Range = inputBoundSheet.getRange(`${columnDataRangeValues}`);
      inputMessageDataRange.dataValidation.rule = {
        custom: {
          formula: "TRUE", // Always valid, just for showing the message
        },
      };
      inputMessageDataRange.dataValidation.prompt = {
        showPrompt: true,
        title: labels.titleForMultiSelectInputMessage,
        message: labels.descriptionForMultiSelectInputMessage,
      };
    }

    //return null;
  }

  //Apply all type of formatting while populating data in excel.
  public static async applyFormatingOnRows(
    activeSheet: Excel.Worksheet,
    beginDataRowIndex: number,
    endDataRowIndex: number,
    beginHeaderRowIndex: number,
    columns: any,
    configuration: EntityConfiguration,
    context,
    meregeRequired: boolean = false
  ) {
    const tableRowHeaderIndex = beginHeaderRowIndex;

    for (let i = 0; i < columns.length; i++) {
      const column = columns[i];
      const cellName = CellIndexMapping[column.CellDisplayIndex];

      if (beginHeaderRowIndex > 0) {
        const generalRange: Excel.Range = activeSheet.getRange(
          `${cellName}${tableRowHeaderIndex}:${cellName}${tableRowHeaderIndex}`
        );

        //To have generic format
        generalRange.format.verticalAlignment = "Top";
        generalRange.format.fill.color = "#747474";
        generalRange.format.font.color = "#ffffff";
        generalRange.format.font.bold = true;
        generalRange.format.horizontalAlignment = "Center";

        ExcelUtilityHelper.drawBorderForCell(
          generalRange,
          column.CellFormat?.DataRowBorderStyle ?? "Continuous",
          column.CellFormat?.DataRowBorderColor ?? "black"
        );

        if (column.CellFormat?.HeaderFillColor) {
          generalRange.format.fill.color = column.CellFormat.HeaderFillColor;
        }
        if (column.CellFormat?.HeaderFontColor) {
          generalRange.format.font.color = column.CellFormat.HeaderFontColor;
        }

        if (column.CellFormat?.HeaderHorizontalAlignment) {
          generalRange.format.horizontalAlignment = column.CellFormat.HeaderHorizontalAlignment;
        }
        if (column.CellFormat?.VerticalAlignment) {
          generalRange.format.verticalAlignment = column.CellFormat.VerticalAlignment;
        }

        if (column.CellFormat?.HeaderFontBold) {
          generalRange.format.font.bold = true;
        }
      }

      let dataRowRange = activeSheet.getRange(`${cellName}${beginDataRowIndex}:${cellName}${endDataRowIndex}`);

      //To have generic format
      dataRowRange.format.fill.color = "#ffffff";
      dataRowRange.format.verticalAlignment = "Top";

      //this will create border for all the cell of table
      for (let currentCell = beginDataRowIndex; currentCell <= endDataRowIndex; currentCell++) {
        let dataCell = activeSheet.getRange(`${cellName}${currentCell}:${cellName}${currentCell}`);
        ExcelUtilityHelper.drawBorderForCell(
          dataCell,
          column.CellFormat?.DataRowBorderStyle ?? "Continuous",
          column.CellFormat?.DataRowBorderColor ?? "black"
        );
      }

      // For applying string format to column for complete data rows in excel
      if (column.CellFormat.disableDefaultFormatting) {
        dataRowRange.numberFormat = [["@"]];
      }

      if (column.CellFormat?.RowsFillColor) {
        dataRowRange.format.fill.color = column.CellFormat.RowsFillColor;
      }

      //NOT USED
      // if (column.CellFormat?.RowsFontColor) {
      //   dataRowRange.format.font.color = column.CellFormat.RowsFontColor;
      // }

      if (column.CellFormat.HorizontalAlignment) {
        dataRowRange.format.horizontalAlignment = column.CellFormat.HorizontalAlignment;
      }

      if (column.CellFormat?.VerticalAlignment) {
        dataRowRange.format.verticalAlignment = column.CellFormat.VerticalAlignment;
      }

      if (column?.CellFormat?.autofitColumns) {
        dataRowRange.format.autofitColumns();
      }
      if (column?.CellFormat?.autofitRows) {
        dataRowRange.format.autofitRows();
      }
      if (meregeRequired) {
        if (column?.mergeCellRanges) {
          for (let i = 0; i < column.mergeCellRanges.length; i++) {
            const mergeCellRange = column.mergeCellRanges[i];
            let range = activeSheet.getRange(mergeCellRange);
            range.merge(false);
          }
        }

        if (column.CellFormat.requiredColumnWidth) {
          dataRowRange.format.columnWidth = column.CellFormat.requiredColumnWidth;
        }
      }
      if (!meregeRequired) {
        if (column.CellFormat?.wrapText) {
          let dataRowRange = activeSheet.getRange(`${cellName}${tableRowHeaderIndex}:${cellName}${endDataRowIndex}`);
          dataRowRange.format.wrapText = true;
        }
      }
    }
  }

  async applyFormattingOnCellChange(
    activeSheet: Excel.Worksheet,
    beginDataRowIndex: number,
    endDataRowIndex: number,
    configuration: EntityConfiguration,
    requestsModel: ServiceDataModel
  ): Promise<any> {}
}
